import { gql } from 'graphql-request'
import { ServerBusinessRefundSettingsType } from '../../generated/graphql-types'
import { reportGqlError, request, useQuery } from '../../api'
import { BUSINESS_REFUND_SETTINGS_QUERY_KEY } from './queryKeys'
import { businessRefundSettingsFragment } from './businessRefundSettings.fragments'

export const useFetchBusinessRefundSettings = () => {
  return useQuery<ServerBusinessRefundSettingsType | undefined>(
    [BUSINESS_REFUND_SETTINGS_QUERY_KEY],
    async () => {
      const result = await request(gql`
        ${businessRefundSettingsFragment}
        query {
          businessRefundSettings {
            ...businessRefundSettingsType
          }
        }
      `)

      if (result?.businessRefundSettings[0]) {
        return result.businessRefundSettings[0]
      }

      return null
    },
    {
      queryName: 'useFetchBusinessRefundSettings',
      onError: reportGqlError,
    },
  )
}
